import { API } from 'service/API'

import { INetworkServiceInterface } from '../NetworkService'
import { IContactJSON, IContactResJSON } from './ContactsModel'

export class ContactsService implements INetworkServiceInterface {
  API: API

  constructor(api: API) {
    this.API = api
  }

  getAll = (): Promise<IContactResJSON> => {
    return this.API.network.contacts.getContacts()
  }

  get = (_id: string): Promise<IContactJSON> => {
    return this.API.network.contacts.getContact(_id)
  }

  findByIds = (_ids: string[]): Promise<IContactJSON[]> => {
    if (!_ids.length) {
      return Promise.resolve([])
    }
    return this.API.network.contacts.getManyContact(_ids.join(','))
  }

  // @ts-expect-error TS(2416) FIXME: Property 'search' in type 'ContactsService' is not... Remove this comment to see the full error message
  search = (searchText: string, organizationId: string): Promise<IContactResJSON> => {
    return this.API.network.contacts.searchContact(searchText, organizationId)
  }

  save = (contact: Partial<IContactJSON>): Promise<IContactJSON> => {
    return this.API.network.contacts.saveContact(contact)
  }

  delete = (contactId: string): Promise<void> => {
    return this.API.network.contacts.deleteContact(contactId)
  }
}
